import React, { useEffect, useState } from 'react';
import api from '../api/api';
import MainLoading from '../view/components/loading/main-loading';

export const Context = React.createContext(null);

function GlobalDataProvider({ children }) {
  const [options, setOptions] = useState(null);
  const [dataIsLoaded, setDataIsLoaded] = useState(false);
  const [categories, setCategories] = useState(null);
  const [gCategories, setGCategories] = useState(null);
  const [currentRoute, setCurrentRoute] = useState('');

  const optionsManager = {
    updateLogo: (link) => {
      setOptions((prevOptions) => {
        const updatedOptions = prevOptions;
        updatedOptions.logo = link;
        return { ...prevOptions, ...updatedOptions };
      });
    },
    updateOptions: (options) => {
      const keys = Object.keys(options);
      setOptions((prevOptions) => {
        const updatedOptions = prevOptions;
        for (const key of keys) {
          updatedOptions[key] = options[key];
        }
        return { ...prevOptions, ...updatedOptions };
      });
    },
    updateTitle: (title) => {
      setOptions((prevOptions) => {
        const updatedOptions = prevOptions;
        updatedOptions.title = title;
        return { ...prevOptions, ...updatedOptions };
      });
    },
    updateRubika: (rubika) => {
      setOptions((prevOptions) => {
        const updatedOptions = prevOptions;
        updatedOptions.rubika = rubika;
        return { ...prevOptions, ...updatedOptions };
      });
    },
    updateInstagram: (instagram) => {
      setOptions((prevOptions) => {
        const updatedOptions = prevOptions;
        updatedOptions.instagram = instagram;
        return { ...prevOptions, ...updatedOptions };
      });
    },
    updateAboutUs: (about_us) => {
      setOptions((prevOptions) => {
        const updatedOptions = prevOptions;
        updatedOptions.about_us = about_us;
        return { ...prevOptions, ...updatedOptions };
      });
    },
  };

  const categoryManager = {
    updateCategories: (list) => {
      setCategories(list);
    },
    updateCategory: (id, dataObject) => {
      const keys = Object.keys(categories);
      for (let key of keys) {
        if (parseInt(categories[key].id) === parseInt(id)) {
          setCategories((prevCategories) => {
            const updated = prevCategories;

            Object.keys(dataObject).map((prop) => {
              updated[key][prop] = dataObject[prop];
              return true;
            });

            return { ...prevCategories, ...updated };
          });
          break;
        }
      }
    },
    deleteCategory: (id) => {
      const keys = Object.keys(categories);
      for (let key of keys) {
        if (parseInt(categories[key].id) === parseInt(id)) {
          setCategories((prevCategories) => {
            const updated = prevCategories;
            delete updated[key];
            return { ...prevCategories, ...updated };
          });
          break;
        }
      }
    },
  };

  const gCategoryManager = {
    updateCategories: (list) => {
      setGCategories(list);
    },
    updateCategory: (id, dataObject) => {
      const keys = Object.keys(gCategories);
      for (let key of keys) {
        if (parseInt(gCategories[key].id) === parseInt(id)) {
          setGCategories((prevCategories) => {
            const updated = prevCategories;

            Object.keys(dataObject).map((prop) => {
              updated[key][prop] = dataObject[prop];

              return true;
            });

            return { ...prevCategories, ...updated };
          });
          break;
        }
      }
    },
    deleteCategory: (id) => {
      const keys = Object.keys(gCategories);
      for (let key of keys) {
        if (parseInt(gCategories[key].id) === parseInt(id)) {
          setGCategories((prevCategories) => {
            const updated = prevCategories;
            delete updated[key];
            return { ...prevCategories, ...updated };
          });
          break;
        }
      }
    },
  };

  const [deletedPostList, setDeletedPostList] = useState({ home: [], category: [], gCategory: [] });
  const [postListPart, setPostListPart] = useState('');
  const deletedPostManager = {
    setPart: (part) => {
      setPostListPart(part);
    },
    part: postListPart,
    addDeletedId: (id, alsoAddToHomeList) => {
      if (alsoAddToHomeList && postListPart !== 'home') {
        const list = deletedPostList[postListPart];
        list.push(id);
        const homeList = deletedPostList.home;
        homeList.push(id);
        setDeletedPostList((prevData) => {
          const update = prevData;
          update[postListPart] = list;
          update.home = homeList;

          return { ...prevData, ...update };
        });
      } else {
        const list = deletedPostList[postListPart];
        list.push(id);
        setDeletedPostList((prevData) => {
          const update = prevData;
          update[postListPart] = list;

          return { ...prevData, ...update };
        });
      }
    },
    inList: (id) => {
      if (postListPart.length > 0) {
        const list = deletedPostList[postListPart];

        for (let i = 0; i < list.length; i++) {
          if (list[i] === id) {
            return true;
          }
        }
      }
      return false;
    },
    getList: (part) => {
      return part === undefined ? deletedPostList[postListPart] : deletedPostList[part];
    },
    getListCount: () => {
      return deletedPostList[postListPart].length;
    },
    reset: (part) => {
      if (part) {
        setDeletedPostList((prevData) => {
          const update = prevData;
          update[part] = [];

          return { ...prevData, ...update };
        });
      } else {
        setDeletedPostList((prevData) => {
          const update = prevData;
          update[postListPart] = [];

          return { ...prevData, ...update };
        });
      }
    },
  };

  // ---------------------------------------------------------------------------------------------------------------------------------------------
  /*
    const history = {};
    [history.list, history.setList] = useState({list: ['/']}); // add home path in first item.
    history.push = path => {
        history.setList(prevData => {
            let list = prevData.list;
            list.push(path);

            const updated = {list: list};

            return {...prevData, ...updated}
        });
    };
    */
  // ---------------------------------------------------------------------------------------------------------------------------------------------
  const p = {}; // provider

  p.options = options;
  p.optionsManager = optionsManager;

  p.currentRoute = currentRoute;
  p.setCurrentRoute = (route) => {
    setCurrentRoute(route);
  };

  p.deletedPostManager = deletedPostManager;

  p.categories = categories;
  p.categoryManager = categoryManager;
  p.gCategories = gCategories;
  p.gCategoryManager = gCategoryManager;

  p.postListPart = postListPart;

  // <page post provider>
  p.post = {};
  [p.post.data, p.post.setData] = useState(null);
  [p.post.loaded, p.post.setLoaded] = useState('loading');
  p.post.loadData = (id) => {
    if (p.post.loaded === 'ok') {
      p.post.setLoaded('loading');
    }

    api
      .getPost(id, postListPart)
      .then((data) => {
        if (data.post) {
          if (postListPart.length === 0) {
            const plp = data.post.category.section === 'c' ? 'category' : 'gCategory';
            setPostListPart(plp);
          }
          p.post.setData(data.post);
          p.post.setLoaded('ok');
        } else {
          p.post.setLoaded('error');
        }
      })
      .catch(() => {
        p.post.setLoaded('error');
      });
  };
  p.post.update = (data) => {
    const keys = Object.keys(data);
    p.post.setData((prevState) => {
      const newState = prevState;
      for (const key of keys) {
        newState[key] = data[key];
      }
      return { ...prevState, ...newState };
    });
  };
  // </page post provider>
  // ---------------------------------------------------------------------------------------------------------------------------------------------

  useEffect(() => {
    api.initial().then((data) => {
      setOptions(data.options);
      setCategories(data.categories);
      setGCategories(data.g_categories);
      setDataIsLoaded(true);
    });
  }, []);

  if (dataIsLoaded) {
    return <Context.Provider value={p}>{children}</Context.Provider>;
  } else {
    return <MainLoading />;
  }
}

export default GlobalDataProvider;
